import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Router, ActivatedRoute } from "@angular/router";
import { CustomHttp } from "../../../common/customHttp.service";
import { ApiUrl } from "../../../common/apiUrls";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { ValidationService } from "../../../common/validationservice";
import { MainAppComponent } from "../../../layout/layout.component";
import "rxjs/add/operator/map";
import { CustomerModel } from "../../../common/viewModels/Admin/CustomerModel";
declare var $: any;

@Component({
  selector: "edituserprofilesettings",
  templateUrl: "./edituserprofilesettings.component.html",
  styleUrls: ["./edituserprofilesettings.component.scss"],
})
export class EditUserProfileSettings implements OnInit {
  File: any;
  name: any;
  ImgBinary: any;
  extension: any;
  userProfileForm: FormGroup;
  resetPasswordForm: FormGroup;
  customers: CustomerModel[];

  isResetSubmit: boolean = false;
  isSubmitted: boolean = false;
  roleId: any;
  userTypeId: any;
  constructor(
    public _router: Router,
    private _formBuilder: FormBuilder,
    private _http: CustomHttp,
    private _appUrl: ApiUrl,
    private _route: ActivatedRoute,
    private _validationService: ValidationService,
    private _mApp: MainAppComponent,
    private _toastrService: ToastrService,
  ) {}

  ngOnInit() {
    this.GetUserProfile();
    this.GetCustomers();
    this.userProfileForm = this._formBuilder.group({
      UserId: [0],
      ProfileName: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(100),
        ]),
      ],
      PageSize: [
        "",
        Validators.compose([
          Validators.required,
          this._validationService.ValidateDropdownList,
        ]),
      ],
      PrimaryCompanyId: [""],
      PrimaryCompanyName: [""],
      Image: [""],
    });

    this.resetPasswordForm = this._formBuilder.group({
      UserId: ["0"],
      passwords: this._formBuilder.group(
        {
          Password: [
            "",
            Validators.compose([
              Validators.required,
              Validators.minLength(6),
              Validators.maxLength(15),
            ]),
          ],
          ConfirmPassword: ["", Validators.compose([Validators.required])],
        },
        { validator: this._validationService.PasswordMatch },
      ),
    });
  }

  resetPassword() {
    this.resetPasswordForm.reset();
    this.resetPasswordForm.markAsPristine();
    this.resetPasswordForm.markAsUntouched();
    this.resetPasswordForm.clearAsyncValidators();
  }

  GetUserProfile() {
    this._mApp.ShowLoader();
    this._http.get(this._appUrl.GetUserProfile).subscribe(
      (data) => {
        this._mApp.HideLoader();
        if (data.json().Result != null) {
          this.userProfileForm.setValue(data.json().Result);
          this.File = data.json().Result.Image;
        }
        const currentUser = JSON.parse(localStorage.getItem("currentUser"));
        if (
          currentUser != null &&
          currentUser != "" &&
          currentUser != undefined
        ) {
          this.roleId = parseInt(currentUser.RoleId);
          this.userTypeId = parseInt(currentUser.UserTypeId);
        }
      },
      (error) => {
        this._mApp.HideLoader();
        this._toastrService.error(error.json().Result);
      },
    );
    this.roleId = parseInt(this._mApp.roleId);
    this.userTypeId = parseInt(this._mApp.userTypeId);
  }
  GetCustomers() {
    this._http.get(this._appUrl.GetCustomersMinInfoList).subscribe(
      (data) => {
        if (data.json().Result != null) this.customers = data.json().Result;
      },
      (error) => {
        this._toastrService.error(error.json().Result, "");
      },
    );
  }

  fileChange(evt) {
    var files = evt.target.files;
    var file = files[0];
    this.name = file.name.split(".");
    var filesize = file.size;
    if (files && file) {
      var ext = file.name.split(".").pop();
      this.extension = ext;
      if (ext == "jpeg" || ext == "png" || ext == "gif" || ext == "jpg") {
        if (filesize < 2148576) {
          $("#fileUpError").hide();
          $("#fileSizeError").hide();
          var myReader: FileReader = new FileReader();
          myReader.onload = (e) => {
            this.File = myReader.result;
          };
          myReader.readAsDataURL(file);
        } else {
          $("#fileSizeError").show();
        }
      } else {
        this._toastrService.error("Please select only Image files", "");
        $("#fileUpload").val("");
      }
    }
  }

  OnSubmit() {
    this.isSubmitted = true;
    if (this.userProfileForm.valid) {
      if(this.File == null || this.File == undefined || this.File == "") {
        this._toastrService.error("Please upload image", "");
        return;
      } 
      this._mApp.ShowLoader();
      let userProfile = this.userProfileForm.value;
      userProfile.ImgBinary = this.File;
      this._http
        .post(this._appUrl.UpsertUserProfileSettings, userProfile)
        .subscribe(
          (data) => {
            this._mApp.HideLoader();
            this._toastrService.success(data.json().Result, "");
            this._mApp.GetUserProfile();
            this._router.navigate(["/login"]);
          },
          (error) => {
            this._mApp.HideLoader();
            this._toastrService.error(error.json().Result, "");
          },
        );
    }
  }

  OnPasswordSubmit() {
    this.isResetSubmit = true;
    if (this.resetPasswordForm.valid) {
      let password = this.resetPasswordForm.value;
      password.UserPwd = this.resetPasswordForm.value.passwords.Password;
      password.IsSelfPwdUpdate = true;
      this._http.post(this._appUrl.UpdatePassword, password).subscribe(
        (data) => {
          this._mApp.HideLoader();
          this.resetPasswordForm.reset();
          this._toastrService.success("Password updated successfully.", "");
          $("#resetPasswordModel").toggle("modal");
        },
        (error) => {
          this._mApp.HideLoader();
          this._toastrService.error(error.json().Result, "");
        },
      );
    }
  }
}
